
import esriRequest from "@arcgis/core/request";

/**
 * Convierte URLs de idearagon.aragon.es para usar el proxy local en desarrollo
 * @param {string} url - URL original
 * @returns {string} URL convertida para usar proxy si está en desarrollo
 */
export const getProxiedUrl = (url) => {
    if (!url) return url;
    
    // Solo aplicar proxy en desarrollo (localhost:3000)
    if (window.location.origin.startsWith("http://localhost:3000")) {
        // Reemplazar cualquier URL de idearagon.aragon.es con el proxy
        if (url.includes("https://idearagon.aragon.es")) {
            const proxiedUrl = url.replace("https://idearagon.aragon.es", "/arcgis-proxy");
            console.log(`[getProxiedUrl] Convirtiendo URL: ${url} -> ${proxiedUrl}`);
            return proxiedUrl;
        }
    }
    return url;
};

export class MapUtilities {

    constructor(mapDiv, mapView, mapConfig) {
        this.mapDiv = mapDiv;
        this.mapView = mapView;
        this.mapConfig = mapConfig;
    }

    getMapImageLayer(visible, name) {
        let out = null;
        let layers = this.getMapImageLayers(visible);
        for (let i in layers) {
            if (layers[i].mapLayer != null && layers[i].mapLayer.name == name) {
                out = layers[i];
            }
        }
        return out;
    }

    getMapImageLayers(visible) {
        return this.getConfigLayers(visible, "MapImageLayer");
    }

    getWMSLayers(visible) {
        return this.getConfigLayers(visible, "WMSLayer");
    }
    /*
    getFieldHasDomains(layerName, sublayerId, fieldName) {
        let out = false;
        let field = this.getField(layerName, sublayerId, fieldName);
        if (!field) return out;

        return field.domain != null;
    }*/

    /*
    getFieldDomains(layerName, sublayerId, fieldName) {
        let out = null;
        if (this.getFieldHasDomains(layerName, fieldName)) {
            let field = this.getField(layerName, sublayerId, fieldName);
            out = field.domain
        }
        return out;
    }*/

    /*
    async getField(layerName, sublayerId, fieldName) {
        let out = null;
        let mapImageLayer = this.getMapImageLayer(false, layerName);


        //console.log("sublayer", sublayerId)
        //console.log("AAAAAAAAAAA", mapImageLayer)

        let url = mapImageLayer.mapLayer.conf.url + "/" + sublayerId;


        let getResponse = (async () => {
            return await esriRequest(url, {
                responseType: "json",
                query: {
                    f: "json"
                }
            });
        });

        let response = await getResponse();
        //console.log("response", response)

        for (let i in response.data.fields) {
            if (response.data.fields[i].name == fieldName) {
                out = response.data.fields[i];
            }
        }

        return out;
    }*/

    async getFields(layerName, sublayerId) {        
        let mapImageLayer = this.getMapImageLayer(false, layerName);

        if(mapImageLayer == null || mapImageLayer.mapLayer == null) return [];
        
        let url = mapImageLayer.mapLayer.conf.url + "/" + sublayerId;


        let getResponse = (async () => {
            return await esriRequest(url, {
                responseType: "json",
                query: {
                    f: "json"
                }
            });
        });

        let response = await getResponse();
        return response.data.fields;

    }

    getConfigLayers(visible, type) {
        let out = [];
        for (var i in this.mapConfig.sgvmapMapMaplyrList) {
            var ly = this.mapConfig.sgvmapMapMaplyrList[i];
            if (ly.sgvmapMapLayer.type == type) {
                if (visible) {
                    let mapLayerView = this.getMapLayerView(ly.sgvmapMapLayer.name, visible);
                    if (mapLayerView != null) out.push(ly);
                }
                else {
                    out.push(ly);
                }
            }
        }
        return out;
    }
    getMapLayerView(name, visible) {
        let out = null;
        for (let layerView of this.mapView.layerViews) {
            if (layerView.layer.title == name) {
                if (visible) {
                    if (layerView.visible) {
                        out = layerView;
                    }
                }
                else {
                    out = layerView;
                }
            }
        }
        return out;
    }
}